export function getTraceId(response) {
  try {
    var _ref, _response$headers$get;
    return (_ref = (_response$headers$get = response.headers.get('x-trace-id')) !== null && _response$headers$get !== void 0 ? _response$headers$get : response.headers.get('atl-traceid')) !== null && _ref !== void 0 ? _ref : null;
  } catch (_unused) {
    return null;
  }
}